/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { useContext, useEffect, useRef, useState } from "react";
import {
	Menu,
	MenuItem,
	Sidebar as ProSidebar,
	SubMenu,
	menuClasses,
} from "react-pro-sidebar";
import { RiContactsBook2Line } from "react-icons/ri";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { IoIosLogOut, IoMdArrowDropdown } from "react-icons/io";
import { getAuth } from "firebase/auth";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UsersApi from "../API/UsersApi";
import {
	ConnectionContext,
	MenuItemsContext,
	NotificationsContext,
	UserContext,
} from "../App";
import Breadcrumbs from "./examples/Breadcrumbs";
import { SearchFiltersContext } from "../App";
import anonUser from "../assets/images/userGrey.png";
import StringIntReq from "../Requests/StringIntReq";
import { ClickAwayListener } from "@mui/material";
import BulkMarkNotificationsAsSeenReq from "../Requests/Notifications/BulkMarkNotificationsAsSeenReq";
import ManyToManyReq from "../Requests/ManyToManyReq";
import CustomerApi from "../API/CustomerApi";
import Swal from "sweetalert2";
import Badge from "@mui/material/Badge";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Notification from "./icons/notification.png";
import Search from "./icons/search.png";
import Logo from "./icons/logo.png";
import SMlogo from "./icons/smlogo.png";
import "./sidebar.scss";
import { LogOutIcon, MapIcon, Settings } from "lucide-react";
import ContextMenu from "../components/ContextMenu";
import { useMode } from "../Layouts/ModeContext";
import {
	searchLocation,
	getSuggestionDetails,
} from "../Views/TeamAdmin/MapPage/components/SearchLocation";

const Item = ({ title, to, icon, selected, setSelected, isLast, active }) => {
	return (
		<MenuItem
			rootStyles={{
				["." + menuClasses.button]: {
					color: "var(--text-color)",
					fontSize: "0.9rem",
					textTransform: "uppercase",
					"&:hover": {
						color: "var(--primary-color)",
					},
					"&:active": {
						color: "var(--primary-color)",
					},
				},
			}}
			active={active}
			component={<Link to={to} />}
			icon={icon(active ? "var(--primary-color)" : "var(--text-color)")}
			onClick={() => setSelected(title)}
		>
			<div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
				{title}
			</div>
		</MenuItem>
	);
};

const Sidebar = ({ children }) => {
	const menuItems = useContext(MenuItemsContext);
	const connectionService = useContext(ConnectionContext);
	const { notifications, setNotifications } = useContext(NotificationsContext);
	const user = useContext(UserContext);
	const [isCollapsed, setIsCollapsed] = useState(false);
	const [showSideBar, setShowSideBar] = useState(false);
	const [showOverlay, setShowOverlay] = useState(showSideBar);
	const [selected, setSelected] = useState("Dashboard");

	const [toggled, setToggled] = useState(false);
	const [breakPoint, setBreakPoint] = useState(false);
	const { mode, setMode } = useMode();
	const navigate = useNavigate();
	const route = useLocation().pathname.split("/").slice(1);
	const activeMenuItem = menuItems.find(
		(item, index) => item.route === `/${route[0]}`,
	);
	const [notificationPanel, setNotificationPanel] = useState(false);
	const [isSearchOpen, setIsSearchOpen] = useState(false);

	const [anchorEl, setAnchorEl] = useState(null);
	const searchBoxRef = useRef(null);

	const handleArrowClick = () => {
		const newCollapsedState = !isCollapsed;
		setIsCollapsed(newCollapsedState);

		if (breakPoint) {
			setToggled(!toggled);
			setIsCollapsed(false);
		}
	};
	useEffect(() => {
		setShowOverlay(showSideBar);
	}, [showSideBar]);

	const bulkMarkNotificationsAsSeen = async () => {
		const req = new BulkMarkNotificationsAsSeenReq();
		req.notificationIds = notifications
			.filter((notification) => !notification.seen)
			.map((notification) => notification.id);
		setNotifications((prev) =>
			prev.map((notification) => {
				if (req.notificationIds.includes(notification.id)) {
					return { ...notification, seen: true };
				}
				return notification;
			}),
		);
		const res = await UsersApi.BulkMarkNotificationsAsSeen(req);
		if (res?.status?.success) {
			console.log("All notifications marked as seen");
		}
	};

	const profileMenu = [
		{
			title: "Settings",
			icon: (color) => (
				<Settings fontSize="medium" sx={{ color: color + " !important" }} />
			),
			onClick: () => {
				navigate("/edit-account-details");
			},
		},
		{
			title: "Logout",
			icon: (color) => (
				<LogOutIcon fontSize="medium" sx={{ color: color + " !important" }} />
			),
			onClick: () => {
				if (
					connectionService &&
					typeof connectionService.StopConnection === "function"
				) {
					console.log("Stopped Notificaiton Connection Service");
					connectionService.StopConnection();
				}
				localStorage.removeItem("searchFilters");
				localStorage.removeItem("contactCenterLeadsFilter");
				getAuth().signOut();
				navigate("/");
				window.location.reload();
			},
		},
	];

	const [query, setQuery] = useState("");
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [showDropdown, setShowDropdown] = useState(false);

	const handleResultClick = async (item) => {
		if (item.isMenuItem) {
			navigate(item.route);
		} else if (item.isLocation) {
			try {
				const res = await getSuggestionDetails(item.place_id);

				if (res?.result?.geometry?.location) {
					const { lat, lng } = res.result.geometry.location;

					navigate("/map", {
						state: {
							location: { lat, lng },
							zoom: 20, // Adjust zoom level
						},
					});

					console.log("Navigated to /map with state:", { lat, lng });
				} else {
					Swal.fire({
						icon: "error",
						title: "Location Not Found",
						text: "Could not retrieve location details.",
					});
				}
			} catch (error) {
				console.error("Error fetching location details:", error);
				Swal.fire({
					icon: "error",
					title: "Error",
					text: "Failed to fetch location details.",
				});
			}
		} else {
			setQuery(item.name);
			setShowDropdown(false);
		}
	};

	// Handle Input Change
	const handleInputChange = (e) => {
		const value = e.target.value || "";
		setQuery(value);
		setError(""); // Clear error on new input
		setShowDropdown(value.trim().length > 0); // Show dropdown only if input is not empty
	};

	const searchMenuItems = (items, searchValue) => {
		const matches = [];
		items.forEach((item) => {
			if (
				item.name &&
				item.name.toLowerCase().includes(searchValue.toLowerCase())
			) {
				// Mark menu items with `isMenuItem`
				item.isMenuItem = true; // Mark it as a menu item
				matches.push(item);
			}
			if (item.items && Array.isArray(item.items)) {
				matches.push(...searchMenuItems(item.items, searchValue));
			}
		});
		return matches;
	};

	const searchFilter = useContext(SearchFiltersContext);

	// Function to navigate to the contact center for the specific customer
	const goToContactCenterForSingleCustomer = (lead) => {
		let name = lead.fidiumCustomer
			? `${lead.fidiumCustomer.firstName} ${lead.fidiumCustomer.lastName}`
			: lead.name?.trim() || lead.fiberHouse?.mapString || "Unknown";

		searchFilter.current = {
			...searchFilter.current,
			contactCenter: {
				...searchFilter?.current?.contactCenter,
				customerName: `${name}`,
			},
		};
		setShowDropdown(false);
		navigate("/contact-center"); // Navigate to contact center when clicking on name
	};
	// Function to open the map for the specific customer's coordinates
	const openMapSearch = (customer) => {
		if (customer.fiberHouse && customer.fiberHouse.coordinates) {
			navigate("/map", {
				state: {
					fiberHouse: {
						...customer.fiberHouse,
						leadId: customer.id,
						lead: { ...customer, fiberHouse: null },
					},
				},
			});
		} else {
			Swal.fire({
				icon: "error",
				title: "No Coordinates",
				text: "This lead does not have any coordinates",
			});
		}
	};

	// Update the useEffect for fetching results
	useEffect(() => {
		let isCancelled = false; // To prevent unwanted state updates

		const fetchSearchResults = async () => {
			const searchValue = query.trim();
			if (searchValue === "") return;

			setLoading(true);
			setResults([]); // Clear previous results
			setError(""); // Clear previous errors

			try {
				// Search through menuItems
				const menuSearchResults = searchMenuItems(menuItems, searchValue);

				// Search leads/customers normally
				const req = {
					searchString: searchValue,
					userId: user.id,
					userType: user.userType,
					salesOrgId: user.salesOrgId,
				};
				const response = await CustomerApi.SearchLeadsForSearchBar(req);

				let apiResults = [];
				if (response.data && response.data.length > 0) {
					apiResults = response.data.map((item) => ({
						...item,
						isLocation: false, // Explicitly marking leads/customers
					}));
				}

				let formattedLocations = [];
				if (route[0] === "map") {
					// Only fetch locations if on the map page
					const locationResults = await searchLocation(
						searchValue,
						apiResults,
						[],
					);
					if (locationResults?.results?.length) {
						formattedLocations = locationResults.results.map((loc) => ({
							...loc,
							isLocation: true,
						}));
					}
				}

				if (!isCancelled) {
					setResults([
						...menuSearchResults,
						...apiResults,
						...formattedLocations,
					]);
				}
			} catch (err) {
				if (!isCancelled) {
					console.error(err);
					setError("Failed to fetch results.");
				}
			} finally {
				if (!isCancelled) {
					setLoading(false);
				}
			}
		};

		if (query?.trim()) {
			// Prevent fetching when query is empty
			const delayDebounceFn = setTimeout(fetchSearchResults, 800);
			return () => {
				clearTimeout(delayDebounceFn);
				isCancelled = true;
			};
		}
	}, [query]); // Run only when `query` changes

	const handleClickAway = (e) => {
		e.preventDefault();
		if (!isCollapsed) {
			setIsCollapsed(true);
		} else {
			setShowSideBar(false);
		}
	};

	const handleClickOutside = (event) => {
		if (searchBoxRef.current && !searchBoxRef.current.contains(event.target)) {
			setShowDropdown(false);
		}
	};
	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<>
			{showOverlay && (
				<div
					className="overlay"
					onClick={() => {
						setShowOverlay(false);
						setShowSideBar(false);
						setIsCollapsed(true);
					}}
					style={{
						position: "fixed",
						top: "0",
						left: "0",
						width: "100%",
						height: "100%",
						zIndex: "999",
						backgroundColor: "rgba(0, 0, 0, 0.5)",
					}}
				></div>
			)}

			<div
				style={{
					boxShadow: "none",
					borderBottom: "1px solid #ddd",
					backgroundColor: "var(--bg-grey)",
					touchAction: "none",
				}}
			>
				<ContextMenu
					menuItems={profileMenu}
					anchorEl={anchorEl}
					handleClose={() => {
						setAnchorEl(null);
					}}
					setAnchorEl={setAnchorEl}
				/>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						width: "100%",
						minHeight: "65px",
						alignItems: "center",
						padding: "0 20px",
						backgroundColor: "var(--bg-grey)",
						position: "relative",
						zIndex: "1000",
					}}
				>
					{/* Left Side */}

					<div className=" flex items-center sm:gap-4 gap-0">
						<IconButton
							edge="start"
							color="inherit"
							aria-label="menu"
							className="sm:mr-2 mr-0"
							onClick={() => {
								setShowSideBar(!showSideBar);
								setIsCollapsed(false);
							}}
							sx={{
								outline: "none !important",
								textDecoration: "none",
								border: "none",
								color: showSideBar
									? "var(--primary-color)"
									: "var(--text-color)",
							}}
						>
							<MenuIcon />
						</IconButton>
						<img
							onClick={() => {
								navigate("/");
							}}
							src={Logo}
							alt="Logo"
							className="FullLogo cursor-pointer"
						/>
						<img
							onClick={() => {
								navigate("/");
							}}
							src={SMlogo}
							alt="SMlogo"
							className="smlogo cursor-pointer"
						/>
					</div>

					<Box
						className="searchBox"
						component="form"
						onSubmit={(e) => e.preventDefault()}
					>
						<input
							type="text"
							value={query}
							onChange={handleInputChange}
							placeholder="Search Leads/Customers/Features..."
							className="searchInput"
							style={{
								border: "none",
								outline: "none",
								background: "none",
								width: "100%",
								marginLeft: "8px",
								paddingRight: "30px",
							}}
						/>
						<img src={Search} alt="Search" className="searchIcon" />
						{showDropdown && (
							<div className="dropdown">
								{loading && <p className="loading">Loading...</p>}
								{!loading && error && <p className="error">{error}</p>}
								{!loading &&
									results.length > 0 &&
									results.map((item, index) => {
										console.log({
											isMenuItem: item.isMenuItem,
											isLocation: item.isLocation,
											item
										});
										return (
											<div
												key={index}
												className="dropdown-item"
												style={{
													color: item.fiberHouseId
														? "blue"
														: item.isLocation
															? "#181E4B"
															: "#0038FF", // Blue for locations
													display: "flex",
													justifyContent: "space-between",
													alignItems: "center",
												}}
												onClick={() => {
													if (route[0] === "map") {
														if (item.isLocation) {
															handleResultClick(item); // <- location result
														} else {
															openMapSearch(item); // <- lead result
														}
													} else {
														goToContactCenterForSingleCustomer(item);
													}
												}}
											>
												<span className="itemName">
													{item.name?.trim()
														? item.name
														: item.address ||
															item.formatted_address ||
															"No Name"}
												</span>
												{/* Icons for Customer Items */}
												{!item.isMenuItem && !item.isLocation && (
													<div className="iconsContainer">
														{route[0] === "map" ? (
															<RiContactsBook2Line
																size={20}
																color="blue"
																className="contactIcon"
																onClick={(e) => {
																	e.stopPropagation();
																	goToContactCenterForSingleCustomer(item);
																}}
															/>
														) : (
															<MapIcon
																size={20}
																color="#181E4B"
																className="mapIcon"
																onClick={(e) => {
																	e.stopPropagation();
																	openMapSearch(item);
																}}
															/>
														)}
													</div>
												)}
											</div>
										);
									})}
							</div>
						)}
					</Box>

					<div
						className="absolute left-0 top-full w-full bg-white px-4 py-3 lg:static lg:block lg:w-auto lg:bg-transparent lg:p-0"
						style={{ display: isSearchOpen ? "block" : "none" }}
					>
						<Box
							className=""
							component="form"
							onSubmit={(e) => e.preventDefault()}
						>
							<input
								type="text"
								value={query}
								onChange={handleInputChange}
								placeholder="Search Leads/Customers/Features..."
								className="searchInput"
								style={{
									border: "none",
									outline: "none",
									background: "none",
									width: "100%",
									marginLeft: "8px",
									paddingRight: "30px",
								}}
							/>
							<img src={Search} alt="Search" className="searchIcon" />
							{/* Search Results Dropdown */}
							{showDropdown && (
								<div className="dropdown">
									{loading && <p className="loading">Loading...</p>}
									{!loading && error && <p className="error">{error}</p>}
									{!loading &&
										results.length > 0 &&
										results.map((item, index) => (
											<div
												key={index}
												className="dropdown-item"
												style={{
													color: item.isMenuItem ? "#181E4B" : "#0038FF", // Differentiating menuItems and customer items
													display: "flex",
													justifyContent: "space-between",
													alignItems: "center",
												}}
												onClick={() => handleResultClick(item)} // Navigate on click for menu items
											>
												{/* Display Item Name */}
												<span className="itemName">
													{item.name?.trim()
														? item.name
														: item.address ||
															item.formatted_address ||
															"No Name"}
												</span>{" "}
												{/* Icons for Customer Items */}
												{!item.isMenuItem && (
													<div className="iconsContainer">
														<RiContactsBook2Line
															size={20}
															color="#181E4B"
															className="contactIcon"
															onClick={(e) => {
																e.stopPropagation();
																goToContactCenterForSingleCustomer(item);
															}}
														/>
													</div>
												)}
											</div>
										))}
								</div>
							)}
						</Box>
					</div>

					<div
						className="SmSearch"
						onClick={() => setIsSearchOpen(!isSearchOpen)}
					>
						<img
							src={Search}
							alt="Search"
							style={{ width: "20px", height: "20px" }}
						/>
					</div>

					{
						<div
							style={{
								visibility:
									user?.userType === "SuperAdmin" ? "visible" : "hidden",
							}}
							className="showAllModes"
						>
							<select
								className="border-none outline-none bg-white focus:outline-none"
								value={mode}
								disabled={user?.userType !== "SuperAdmin"}
								onChange={(e) => setMode(e.target.value)}
							>
								<option value="SalesMode">Sales Mode</option>
								<option value="RecruitMode">Recruit Mode</option>
								{route[0] === "map" && (
									<option value="BothMode">Both Modes</option>
								)}
							</select>
						</div>
					}

					{/* Right Side */}

					<div className=" flex items-center gap-0 sm:gap-4">
						<IconButton
							id="not-btn"
							sx={{
								position: "static",
								padding: "0",
								outline: "none !important",
							}}
						>
							<Badge
								onClick={(e) => {
									setNotificationPanel(!notificationPanel);
									bulkMarkNotificationsAsSeen();
								}}
								badgeContent={notifications.filter((n) => !n.seen).length}
								sx={{
									"& .MuiBadge-badge": {
										backgroundColor: "var(--primary-color)",
										color: "white !important",
									},
								}}
							>
								<img
									className="NewNotify"
									src={Notification}
									alt="Notification"
									style={{
										width: "30px",
										height: "30px",
										outline: "none !important",
									}}
								/>
							</Badge>
							{notificationPanel && (
								<ClickAwayListener
									onClickAway={(e) => {
										let isChild = document
											.getElementById("not-btn")
											.contains(e.target);
										if (!isChild) {
											console.log(e.target);
											setNotificationPanel(false);
										}
									}}
								>
									<div className="notification_panel">
										<div
											style={{
												padding: "5px 0",
												display: "flex",
												justifyContent: "space-between",
												alignItems: "center",
											}}
										>
											<h1
												style={{
													color: "var(--border-color)",
													fontSize: "1rem",
													fontWeight: "600",
													textTransform: "uppercase",
													marginLeft: "15px",
												}}
											>
												Notifications
											</h1>

											<p
												style={{ color: "var(--border-color)" }}
												onClick={() => setNotificationPanel(false)}
											>
												x
											</p>
										</div>
										<div className="notification_panel_inner">
											{notifications?.length > 0 ? (
												notifications.map((notification, index) => {
													return (
														<div
															key={index}
															className="notification"
															style={{
																border: !notification.seen
																	? "1px solid var(--light-border)"
																	: "none",
															}}
														>
															<p
																style={{
																	color: "var(--black-color)",
																	fontSize: "10px",
																	fontWeight: "600",
																}}
															>
																{notification.message}
															</p>

															<p
																className="date"
																style={{
																	color: !notification.seen
																		? " var(--primary-color)"
																		: "var(--border-color)",
																}}
															>
																{
																	// if timestamp is today, show time only else show date
																	new Date(
																		notification.timeStamp,
																	).toLocaleDateString() ===
																	new Date().toLocaleDateString()
																		? new Date(
																				notification.timeStamp,
																			).toLocaleTimeString()
																		: new Date(
																				notification.timeStamp,
																			).toLocaleDateString()
																}
															</p>
														</div>
													);
												})
											) : (
												<div className="notification">
													<p>No Notifications</p>
												</div>
											)}
										</div>
									</div>
								</ClickAwayListener>
							)}
						</IconButton>

						<div
							onClick={(e) => {
								setAnchorEl(e.currentTarget);
							}}
							className="NameAndRole"
							style={{
								display: "flex",
								alignItems: "center",
								// marginRight: "2rem",
								backgroundColor: "var(--bg-light)",
								cursor: "pointer",
								borderRadius: "20px",
								gap: "8px",
								height: "45px",
							}}
						>
							<div
								className="NewName"
								style={{ display: "flex", flexDirection: "column", gap: "0" }}
							>
								<Typography
									variant="subtitle2"
									sx={{
										color: "var(--text-color)",
									}}
								>
									{user?.firstName + " " + user?.lastName?.charAt(0) + "."}
								</Typography>

								<Typography
									component="span"
									variant="caption"
									sx={{
										color: "var(--primary-color)",
									}}
								>
									{user?.userType}
								</Typography>
							</div>
							<div className="user_profile relative">
								<img
									className="ProPhoto"
									alt="Avatar"
									src={user?.profileImage ? user?.profileImage?.url : anonUser}
									style={{
										width: 35,
										height: 35,
										borderRadius: "9999px",
									}}
								/>
								<div className="absolute top-[60%] left-[60%] border-2 border-[#E4E4E4] flex justify-center items-center p-[0.5px] bg-white rounded-full">
									<IoMdArrowDropdown
										style={{ color: "var(--color-icon)" }}
										fontSize="15"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{route[route.length - 1] !== "map" ||
				(route[route.length - 1] !== "" && (
					<div
						style={{
							height: "48px",
							display: "flex",
							backgroundColor: "var(--bg-light)",
							alignItems: "center",
							padding: "0 20px",
							// position: "fixed",
							// top: "65px",
							width: "100%",
							zIndex: "100",
						}}
						className="BreadCrumbDiv"
					>
						<Breadcrumbs
							light={document.body.classList.contains("dark")}
							icon={<HomeOutlinedIcon />}
							title={route[route.length - 1]}
							route={route}
						/>
					</div>
				))}

			<div
				style={{
					padding: route[route.length - 1] === "map" ? "0" : "",
					overflow: route[route.length - 1] === "map" ? "hidden" : "",
				}}
				className={`w-full MainDiv md:h-[calc(100vh-125px)] ${
					route[route.length - 1] === "map"
						? "md:mt-0 md:pt-0"
						: "md:mt-2 md:pt-4"
				} mt-0  ${
					route[route.length - 1] === "map"
						? " h-[20vh]"
						: "h-[calc(100vh-70px)]"
				}`}
			>
				<div
					className={`SideBarMain py-0 ${
						route[route.length - 1] === "map" ? "md:py-0 " : "md:py-4"
					}`}
				>
					{children}
				</div>
			</div>

			{showSideBar && (
				<div
					style={{
						display: "flex",
						backgroundImage: `url("/images/banner/background.png")`,
						backgroundPosition: "center",
						backgroundRepeat: "no-repeat",
						backgroundSize: "cover",
						transition: "all 0.5s",
						zIndex: "1000",
					}}
				>
					{menuItems.length > 0 && (
						<ClickAwayListener onClickAway={() => handleClickAway()}>
							<div
								className="flex absolute  left-0 justify-center items-center "
								style={{
									top: "114px",
									// backgroundColor: "red",
									borderTopRightRadius: "25px",
								}}
							>
								<ProSidebar
									rootStyles={{
										height: "calc(100vh - 114px)",
										paddingTop: "1rem",
										backgroundColor: "var(--bg-light) !important",
										zIndex: "1000",
										border: ".5px solid var(--border-color) ",
										scrollbarWidth: "none !important",
										scrollbarColor: "transparent transparent",
										borderTopRightRadius: "25px",
										width: "265px",
										// position: "absolute",
										// top: "0",
										// left: "0",
									}}
									onBackdropClick={() => setToggled(false)}
									onBreakPoint={(e) => {
										setBreakPoint(e);
									}}
									toggled={toggled}
									// breakPoint="md"

									collapsed={isCollapsed}
								>
									<Menu
										menuItemStyles={{
											button: ({ level, active, disabled }) => {
												return {
													// backgroundColor: active ? 'var(--color-icon-hover) !important' : undefined,
													color: active
														? "var(--primary-color)"
														: "var(--text-color)",
													borderTopRightRadius: "25px",
													borderBottomRightRadius: "25px",
													"&:hover": {
														// backgroundColor: '#181E4B',
														// color: '#FFFFFF'
														color: "var(--primary-color)",
													},
												};
											},
										}}
									>
										{menuItems.map((item) =>
											item.groupName ? (
												<SubMenu
													key={item.groupName}
													label={
														<Box sx={{ display: "flex", alignItems: "center" }}>
															{item.icon && item.icon("currentColor", 20)}
															{!isCollapsed && (
																<Typography
																	sx={{
																		ml: 1,
																		fontSize: "0.9rem",
																		textTransform: "uppercase",
																	}}
																>
																	{item.groupName}
																</Typography>
															)}
														</Box>
													}
												>
													{item.items.map((subItem) => (
														<Item
															key={subItem.name}
															title={subItem.name}
															to={subItem.route}
															icon={(color) => subItem.icon(color, 20)}
															selected={selected}
															setSelected={setSelected}
															active={activeMenuItem?.name === subItem.name}
														/>
													))}
												</SubMenu>
											) : (
												<Item
													key={item.name}
													title={item.name}
													to={item.route}
													icon={(color) => item.icon(color, 20)}
													selected={selected}
													setSelected={setSelected}
													active={activeMenuItem?.name === item.name}
												/>
											),
										)}

										<MenuItem
											rootStyles={{
												["." + menuClasses.button]: {
													color: "var(--text-color)",
													fontSize: "0.9rem",
													marginBottom: "5rem",
													"&:hover": {
														// backgroundColor: 'var(--color-icon-hover) !important',
														color: "var(--primary-color)",
													},
													"&:active": {
														// backgroundColor: 'var(--color-icon-hover) !important',
														color: "var(--primary-color)",
													},
												},
											}}
											// active={active}
											// component={<Link to={to} />}
											icon={
												<IoIosLogOut
													size={20}
													sx={{ color: "var(--primary-color) !important" }}
												/>
											}
											onClick={() => {
												if (
													connectionService &&
													typeof connectionService.StopConnection === "function"
												) {
													console.log(
														"Stopped Notificaiton Connection Service",
													);
													try {
														connectionService.StopConnection();
													} catch (e) {
														console.log(e);
													}
												}
												localStorage.removeItem("searchFilters");
												localStorage.removeItem("contactCenterLeadsFilter");
												getAuth().signOut();
												navigate("/");
												window.location.reload();
											}}
										>
											<div
												style={{
													whiteSpace: "normal",
													wordBreak: "break-word",
												}}
											>
												Logout
											</div>
										</MenuItem>
									</Menu>
								</ProSidebar>
								<div
									onClick={handleArrowClick}
									style={{
										right: "-15px",
										zIndex: "1000",
										borderColor: "var(--border-color)",
										cursor: "pointer",
										top: "4rem",
										backgroundColor: " var(--bg-light)",
										color: "var(--primary-color) !important",
										borderRadius: "10px",
									}}
									className="border-2 absolute p-1"
								>
									{isCollapsed ? (
										<ArrowRight
											fontSize="medium"
											sx={{ color: "var(--primary-color) !important" }}
										/>
									) : (
										<ArrowLeft
											sx={{ color: "var(--primary-color) !important" }}
											fontSize="medium"
										/>
									)}
								</div>
							</div>
						</ClickAwayListener>
					)}
				</div>
			)}
		</>
	);
};

export default Sidebar;
